import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loaderStateSubject = new Subject<any>();

  showLoader(loadingText:string="") {
    this.loaderStateSubject.next({ ShowLoader: true, LoadingText: loadingText });
  }

  hideLoader() {
    this.loaderStateSubject.next({ ShowLoader: false, LoadingText: "" });
  }

  getLoaderState() {
    return this.loaderStateSubject.asObservable();
  }
}
